export default {
  'highlights-heading':
    'Ein Ort voller spritziger Ideen, spannender Vorschläge und eine Inspirationsquelle für eure Geschenke',
}
